module.exports = "../../app/cells/pages/questions/question_comments/paywall.erb";